
import React from 'react';
import AppMobileNav from './AppMobileNav';

interface AppLayoutProps {
  children: React.ReactNode;
  showNav?: boolean;
}

const AppLayout = ({ children, showNav = true }: AppLayoutProps) => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-juv-cream-white to-juv-soft-blush">
      {/* App Content */}
      <main className={`${showNav ? 'pb-20' : ''}`}>
        {children}
      </main>
      
      {/* Mobile Navigation */}
      {showNav && <AppMobileNav />}
    </div>
  );
};

export default AppLayout;
